import { GlobalSchemaFields } from '@/api/mongooseTypes';

export class IStore extends GlobalSchemaFields {
  /** @type {string} **/
  sid;
  /** @type {string} **/
  name;
  /** @type {string} **/
  description;

  constructor(obj) {
    super(obj);
    Object.assign(this, obj);
  }
}
